import { render, staticRenderFns } from "./CommentRestriction.vue?vue&type=template&id=55cc30ac"
import script from "./CommentRestriction.vue?vue&type=script&lang=js"
export * from "./CommentRestriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports